export const formStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
};

export const rowsContainerStyles = {
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
};

export const copyButtonStyles = {
  alignSelf: 'flex-start',
};

export const infoLineStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  padding: '12px 16px',
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const errorLineStyles = {
  ...infoLineStyles,
  border: ({ palette }) => `1px solid ${palette.error.main}`,
};

export const infoIconStyles = {
  flexShrink: 0,
  marginTop: '2px',
};

export const loaderStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: '24px',
};

export const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  paddingTop: '16px',
  borderTop: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const footerButtonsStyles = {
  display: 'flex',
  gap: '12px',
};

export const feeSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};
